import { useTranslation } from 'react-i18next';
import { ArrowUp, ArrowUpRight } from '@phosphor-icons/react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';

import {
  TimelineConnectorStyled,
  TimelineContentStyled,
  TimelineDotStyled,
  TimelineStyled,
} from './TimelineStyled';
import { ThemeStatusToBgColorMappingObj } from 'enrollment/app/constants';

export interface CustomizedTimelineProps {
  data?: any;
}

export const CustomizedTimeline = ({
  data = {
    name: '',
    document_requested_on: '',
    document_submitted_on: '',
    status_label: '',
    document_updated_on: '',
  },
}: CustomizedTimelineProps) => {
  const {
    name: documentName,
    document_requested_on: requestedDate,
    document_submitted_on: uploadedDate,
    status_label: statusLabel,
    document_updated_on: pendingReviewDate,
  } = data;

  const { t } = useTranslation('pages.addYourDocuments');

  const color = ThemeStatusToBgColorMappingObj(statusLabel)?.borderColor;

  const formatDate = (date: string) => {
    return moment(date).format('MMMM DD, YYYY | h.mm a');
  };

  return (
    <TimelineStyled $statusLabelColor={color}>
      <Box className="d-flex">
        <Box>
          <TimelineDotStyled $statusLabelColor="">
            <ArrowUpRight size={10} fill="#FFFFFF" />
          </TimelineDotStyled>
          <TimelineConnectorStyled />
        </Box>
        <TimelineContentStyled className="d-flex flex-column">
          <Typography variant="overline" className="overline2" gutterBottom>
            {t('requestedTitle')}
          </Typography>
          <Typography variant="overline" gutterBottom>
            {t('onDateText', { date: formatDate(requestedDate) })}
          </Typography>
        </TimelineContentStyled>
      </Box>

      <Box className="d-flex">
        <Box>
          <TimelineDotStyled $statusLabelColor="">
            <ArrowUp size={10} fill="#FFFFFF" />
          </TimelineDotStyled>
          <TimelineConnectorStyled />
        </Box>
        <TimelineContentStyled className="d-flex flex-column">
          <Typography variant="overline" className="overline2" gutterBottom>
            {t('uploadedtitle')} {documentName}
          </Typography>
          <Typography variant="overline" gutterBottom>
            {t('onDateText', { date: formatDate(uploadedDate) })}
          </Typography>
        </TimelineContentStyled>
      </Box>

      <Box className="d-flex">
        <Box>
          <TimelineDotStyled $statusLabelColor={color} />
        </Box>
        <TimelineContentStyled className="d-flex flex-column">
          <Typography
            variant="overline"
            className="overline2 status-label"
            gutterBottom
          >
            {statusLabel}
          </Typography>
          <Typography variant="overline" gutterBottom>
            {t('onDateText', { date: formatDate(pendingReviewDate) })}
          </Typography>
        </TimelineContentStyled>
      </Box>
    </TimelineStyled>
  );
};
